/** @format */
import { commonSharedModule } from './shared.module';

(function () {
    'use strict';

    angular.module(commonSharedModule).factory('dateTimeService', dateTimeServiceFactory);

    function dateTimeServiceFactory() {
        var api = {
            currentDateTime: function () {
                return moment();
            },
        };

        return api;
    }
})();
